import store from '@/store';

/** 投放内容与目标 */
export {
  platform,
  // 下载链接，landing_type=APP 子目标为 DOWNLOAD 或者LAUNCH 时有效且必填
  download_url,
  // 下载方式，landing_type=APP 子目标为 DOWNLOAD 或者LAUNCH 时有效
  download_type,
  // 优先从系统应用商店下载（下载模式），landing_type=APP 子目标为 DOWNLOAD 或者LAUNCH 时有效
  download_mode,
  // 调起方式， landing_type = APP 且子目标为LAUNCH有效
  launch_type,
  // Deeplink直达链接，landing_type = APP 且子目标为 LAUNCH 时有效且必填
  open_url,
  // ulink直达链接，landing_type = APP 且子目标为LAUNCH 时有效；仅支持穿山甲广告位
  ulink_url,
  // 预约下载链接，landing_type = APP 且子目标为 RESERVE 时有效且必填
  subscribe_url,
  // 小游戏类型，允许值：【微信小游戏 - WECHAT_GAME】【字节小游戏 - BYTE_GAME】，当landing_type为MICRO_GAME必填
  micro_promotion_type,
  // 字节小游戏 - 当micro_promotion_type=BYTE_GAME时必填
  micro_app_instance_id,
};

const platform = {
  label: '平台',
  type: 'radio-group',
  isButton: true,
  filter: true,
  options: store.getters.jrttEnum.api_2_platforms,
  value: 'ANDROID',
  rules: [{ required: true, message: '平台', trigger: 'change' }],
  props: {
    style: {
      width: '300px',
    },
  },
};

/**
 * 投放内容与目标-表单配置
 */

const download_url = {
  label: '下载链接',
  type: 'input',
  options: [],
  app_name: '',
  value: '',
  rules: [{ required: true, message: '请输入下载链接', trigger: 'change' }],
  props: {
    style: {
      width: '300px',
    },
  },
};

const download_type = {
  label: '下载模式',
  type: 'radio-group',
  isButton: true,
  options: [
    {
      label: '直接下载',
      value: 'DOWNLOAD_URL',
    },
    {
      label: '落地页下载',
      value: 'EXTERNAL_URL',
    },
  ],
  value: 'DOWNLOAD_URL',
};

const download_mode = {
  label: '优先应用商城下载',
  type: 'radio-group',
  isButton: true,
  options: [
    {
      label: '不启用',
      value: 'DEFAULT',
    },
    {
      label: '启用',
      value: 'APP_STORE_DELIVERY',
    },
  ],
  value: 'DEFAULT',
};

const launch_type = {
  label: '调起方式',
  type: 'radio-group',
  isButton: true,
  hidden: true,
  options: [
    {
      label: '直接调起',
      value: 'DIRECT_OPEN',
    },
    {
      label: '落地页调起',
      value: 'EXTERNAL_OPEN',
    },
  ],
  value: 'DIRECT_OPEN',
};

/** 当推广目标为应用推广且子目标为应用调用时候必填 */
const open_url = {
  label: 'DeepLink',
  type: 'input',
  hidden: true,
  value: '',
  rules: [{ required: true, message: '请输入Deeplink直达链接', trigger: 'change' }],
};

const ulink_url = {
  label: 'ULink',
  type: 'input',
  hidden: true,
  value: '',
};

/** 当推广目标为应用推广且子目标为预约下载时候必填 */
const subscribe_url = {
  label: '预约下载链接',
  type: 'input',
  hidden: true,
  value: '',
  rules: [{ required: true, message: '请输入预约下载链接', trigger: 'change' }],
};

/** 小游戏类型，允许值：【微信小游戏 - WECHAT_GAME】【字节小游戏 - BYTE_GAME】，当landing_type为MICRO_GAME必填 */
const micro_promotion_type = {
  label: '小游戏类型',
  type: 'select',
  props: {
    disabled: false,
  },
  options: [],
  hidden: true,
  value: '',
  backup_value: '',
  rules: [{ required: true, message: '请选择小游戏类型', trigger: 'change' }],
};

/** 微信/字节小游戏 - 当micro_promotion_type=BYTE_GAME 或 micro_promotion_type=WECHAT_GAME时必填 */
const micro_app_instance_id = {
  label: '字节小游戏',
  hidden: true,
  value: '',
  rules: { required: true, message: '请选择字节小游戏', trigger: 'change' },
};
